module.exports = require("svgo");